/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component} from '@angular/core';
import template from './segment-item-page.component.html';

import {AdminResourceItemPageBase} from '../common/controller/admin-resource-item-page-base';

@Component({
  standalone: false,
  selector: 'adn-segment-item-page',
  template
})
export class SegmentItemPageComponent extends AdminResourceItemPageBase {
  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }
}
